import React from 'react';
import { Box, Flex } from '@react-three/flex';

export const ComicStripRow: React.FC<{
  children: React.ReactElement[];
}> = props => (
  <Flex
    flexDirection={'row'}
    alignItems={'flex-start'}
    align={'flex-start'}
    alignContent={'flex-start'}
  >
    {props.children.map((child, i) => (
      <Box key={i} centerAnchor margin={0.1}>
        {child}
      </Box>
    ))}
  </Flex>
);
